module.exports = __webpack_public_path__ + "img/a11y.240ee07.jpg";